module.exports = __webpack_public_path__ + "img/introduction-team.f265ceb0.png";